import { render, staticRenderFns } from "./merchant-item.vue?vue&type=template&id=48876747&scoped=true&"
import script from "./merchant-item.vue?vue&type=script&lang=ts&"
export * from "./merchant-item.vue?vue&type=script&lang=ts&"
import style0 from "./merchant-item.vue?vue&type=style&index=0&id=48876747&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48876747",
  null
  
)

export default component.exports